export default defineNuxtRouteMiddleware((to) => {
    if (to.path.startsWith('/pt_PT')) {
        const newPath = to.path.replace(/^\/pt_PT/, '/pt')
        return navigateTo(newPath, { replace: true })
    }
})